import Image from "next/image";
import NextLink from "next/link";
import { Button, Typography } from "@/components/ui";
import { useHero, UseHeroProps } from "./use-hero";

export type HeroProps = UseHeroProps;

export const Hero = (props: HeroProps) => {
  const { styles, className, data } = useHero(props);
  const { title, description, cta, image, background } = data;

  return (
    <div className={styles.base({ className })}>
      {!!background && (
        <Image
          fill
          alt={background.alt}
          src={background.src}
          quality="100"
          sizes="100vw"
          className={styles.background()}
        />
      )}
      <div className={styles.container()}>
        <div className={styles.content()}>
          <div className={styles.caption()}>
            <Typography
              as="h1"
              className={styles.title()}
              fontSize="heading-xl"
              fontFamily="chillen"
              spacing="wider"
              lineHeight="loose"
              uppercase
            >
              {title}
            </Typography>
            {!!description && (
              <Typography
                as="p"
                className={styles.description()}
                fontSize="body-xl"
              >
                {description}
              </Typography>
            )}
            {!!cta && (
              <Button
                appearance="outline"
                color="primary-light"
                fontWeight="bold"
                asChild
              >
                <NextLink href={cta.href} title={cta.title}>
                  {cta.title}
                </NextLink>
              </Button>
            )}
          </div>
          {image && (
            <div className={styles.figure()}>
              <Image
                fill
                src={image.src}
                alt={image.alt}
                className={styles.image()}
                quality="100"
                sizes="100vw"
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.isometricWrapper()}>
        <Image
          fill
          alt="Folhas"
          src="/images/hero-leaf.png"
          quality="100"
          sizes="100vw"
          className={styles.isometric()}
        />
      </div>
    </div>
  );
};
